<template>
    <BasePopUp v-if="showModal" @detailsClosed="closeConfirmRequested">
        <div class="modal-body-container">
            <h4 class="text-center mt-4">{{ $t('pickDefault') }}</h4>   
            <div class="d-flex flex-wrap justify-content-between my-2 gap-2">
                <img class="m-1" @click="$emit('imagePicked', getImageName(index + 1))" v-for="(item,index) in arrayAux" :key="index" :src="getImagePath(index + 1)"/>        
            </div>     
            <CButton type="button" class="mb-4 btn btn-primary align-self-center" @click="closeConfirmRequested">{{ $t('close') }}</CButton>
        </div>
    </BasePopUp>
</template>

<script>
import BasePopUp from './BasePopUp.vue';
import { API_HELPER } from "@/helpers/api.js";

export default {
    extends: BasePopUp,
    components: {BasePopUp},
    methods:{
        closeConfirmRequested(event)
        {       
            this.$emit("closeConfirmRequested");
        },
        getImageName(num)
        {
            return `${this.imagePrefix}${num}.jpg`;
        },
        getImagePath(num)
        {
            return API_HELPER.pathJoin([process.env.VUE_APP_DEFAULT_IMAGES_ROOT, this.getImageName(num)]);
        }
    },
    computed:
    {
        arrayAux: function()
        {
            return Array.from({length: this.numImages}, (_, i) => i + 1);
        }
    },
    props:{
        numImages:
        {
            type: Number,
            default: 7
        },
        imagePrefix:
        {
            type: String,
            default: 'default_'
        }
    },
}
</script>

<style scoped>
.modal-body-container
{
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    border-radius: 10px;    
    min-height: 200px;
}

img
{
    max-height: 100px;
    max-width: 30%;
    object-fit: contain;
    cursor: pointer;
}

img:hover
{
    transform: scale(1.01);
}
</style>